"use strict";

require("core-js/modules/es.function.name");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _native = _interopRequireDefault(require("@emotion/native"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Input =
/*#__PURE__*/
_native["default"].TextInput(function (_ref) {
  var theme = _ref.theme;
  return {
    borderWidth: 1,
    borderColor: theme.borderColor || '#e6e6e6',
    borderRadius: 2,
    fontSize: 13,
    padding: 5,
    margin: 10,
    color: theme.labelColor || 'black'
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy90eXBlcy9UZXh0LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUljIiwiZmlsZSI6Ii4uLy4uL3NyYy90eXBlcy9UZXh0LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJztcbmltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL25hdGl2ZSc7XG5cbmNvbnN0IElucHV0ID0gc3R5bGVkLlRleHRJbnB1dCgoeyB0aGVtZSB9KSA9PiAoe1xuICBib3JkZXJXaWR0aDogMSxcbiAgYm9yZGVyQ29sb3I6IHRoZW1lLmJvcmRlckNvbG9yIHx8ICcjZTZlNmU2JyxcbiAgYm9yZGVyUmFkaXVzOiAyLFxuICBmb250U2l6ZTogMTMsXG4gIHBhZGRpbmc6IDUsXG4gIG1hcmdpbjogMTAsXG4gIGNvbG9yOiB0aGVtZS5sYWJlbENvbG9yIHx8ICdibGFjaycsXG59KSk7XG5cbmNvbnN0IFRleHRUeXBlID0gKHsga25vYiwgb25DaGFuZ2UgfSkgPT4gKFxuICA8SW5wdXRcbiAgICBpZD17a25vYi5uYW1lfVxuICAgIHZhbHVlPXtrbm9iLnZhbHVlfVxuICAgIG9uQ2hhbmdlVGV4dD17b25DaGFuZ2V9XG4gICAgYXV0b0NhcGl0YWxpemU9XCJub25lXCJcbiAgICB1bmRlcmxpbmVDb2xvckFuZHJvaWQ9XCJ0cmFuc3BhcmVudFwiXG4gIC8+XG4pO1xuXG5UZXh0VHlwZS5kZWZhdWx0UHJvcHMgPSB7XG4gIGtub2I6IHt9LFxuICBvbkNoYW5nZTogKHZhbHVlKSA9PiB2YWx1ZSxcbn07XG5cblRleHRUeXBlLnByb3BUeXBlcyA9IHtcbiAga25vYjogUHJvcFR5cGVzLnNoYXBlKHtcbiAgICBuYW1lOiBQcm9wVHlwZXMuc3RyaW5nLFxuICAgIHZhbHVlOiBQcm9wVHlwZXMuc3RyaW5nLFxuICB9KSxcbiAgb25DaGFuZ2U6IFByb3BUeXBlcy5mdW5jLFxufTtcblxuVGV4dFR5cGUuc2VyaWFsaXplID0gKHZhbHVlKSA9PiB2YWx1ZTtcblRleHRUeXBlLmRlc2VyaWFsaXplID0gKHZhbHVlKSA9PiB2YWx1ZTtcblxuZXhwb3J0IGRlZmF1bHQgVGV4dFR5cGU7XG4iXX0= */");

var TextType = function TextType(_ref2) {
  var knob = _ref2.knob,
      onChange = _ref2.onChange;
  return _react["default"].createElement(Input, {
    id: knob.name,
    value: knob.value,
    onChangeText: onChange,
    autoCapitalize: "none",
    underlineColorAndroid: "transparent"
  });
};

TextType.defaultProps = {
  knob: {},
  onChange: function onChange(value) {
    return value;
  }
};
TextType.propTypes = {
  knob: _propTypes["default"].shape({
    name: _propTypes["default"].string,
    value: _propTypes["default"].string
  }),
  onChange: _propTypes["default"].func
};

TextType.serialize = function (value) {
  return value;
};

TextType.deserialize = function (value) {
  return value;
};

var _default = TextType;
exports["default"] = _default;